import { EventName } from "#structure/providers/analytics/event-types";

export function normalizeNavUrl(url: string): string {
	return url.replace(/^\/place\/[^/]+/, "");
}

export const NAV_EVENT_BY_URL: Partial<Record<string, EventName>> = {
	// org
	"/clients": "menu_customer_list_clicked",
	"/communication": "menu_message_sending_clicked",
	"/satisfaction-survey#results": "menu_satisfaction_survey_clicked",
	"/reports#revenue": "menu_general_report_clicked",
	"/messages-analytics": "menu_message_report_clicked",
	"/giftback": "menu_giftback_clicked",
	"/internal-sales-campaign": "menu_sales_campaign_clicked",
	// place
	"/employees": "menu_pdv_operators_clicked",
	"/entrance": "menu_entrance_clicked",
	"/manage-menu": "menu_products_menus_clicked",
	"/products": "menu_products_menus_clicked",
	"/bars": "menu_bars_sectors_clicked",
	"/promotions": "menu_bonus_promo_discount_clicked",
	// place · submenu Relatórios
	"/financial-report#/FinancialReport": "menu_reports_financial_clicked",
	"/bar-reports#/SoldProducts": "menu_reports_sales_clicked",
	"/entrance-reports#/boxOfficeBilling": "menu_reports_entrance_clicked",
	"/table-reports#general": "menu_reports_table_clicked",
	"/operation-place-transactions-report": "menu_reports_operation_clicked",
	// place · submenu Configuração
	"/settings": "menu_settings_general_clicked",
	"/password-card": "menu_settings_password_card_clicked",
	"/contracts": "menu_settings_contracts_clicked",
	"/place-data": "menu_settings_contract_info_clicked",
	"/audits": "menu_settings_audit_clicked",
};

export const NAV_PARENT_EVENT_BY_FIRST_SUBMENU_URL: Partial<Record<string, EventName>> = {
	// org
	"/clients": "menu_crm_clicked",
	"/reports#revenue": "menu_org_reports_clicked",
	// place
	"/financial-report#/FinancialReport": "menu_reports_clicked",
	"/settings": "menu_settings_clicked",
	"/guest-lists": "menu_receptive_clicked",
	"/kds": "menu_kds_clicked",
	"/attendance-management": "menu_table_map_clicked",
};
